export const CUSTOMER_TYPES = [
  "Homeowner / Individual", "Farmer / Landowner", "Business / Corporate",
  "Architect / Landscaper", "Builder / Developer", "Hotel / Resort",
  "School / Institution", "Government / NGO", "Other",
];

export const STATES = [
  "Assam", "Arunachal Pradesh", "Meghalaya", "Nagaland", "Manipur", "Mizoram",
  "Tripura", "Sikkim", "Other",
];

export const TIME_SLOTS = ["Morning · 9 AM–12 PM", "Afternoon · 12 PM–4 PM", "Evening · 4 PM–6 PM"];

export const PROPERTY_TYPES = [
  "Home / Villa", "Apartment", "Terrace / Rooftop", "Farm / Agricultural Land",
  "Office / Corporate Campus", "Hotel / Resort", "Commercial Property",
  "School / College", "Hospital / Institution", "Open Land", "Other",
];

export const AREA_UNITS = ["Sq. Ft.", "Sq. Meter", "Bigha", "Acre", "Hectare"];

export const NEEDS_OPTIONS = [
  "New Garden", "Garden Renovation", "Landscape Design", "Plantation", "Indoor Plants",
  "Outdoor Plants", "Terrace Garden", "Balcony Garden", "Lawn", "Vertical Garden",
  "Irrigation", "Maintenance / AMC", "Bulk Plants", "Forestry", "Fruit / Horticulture",
];

export const BUDGET_OPTIONS = [
  "Not decided yet", "Below ₹10,000", "₹10,000–₹25,000", "₹25,000–₹50,000",
  "₹50,000–₹1 lakh", "₹1–₹5 lakh", "₹5–₹10 lakh", "Above ₹10 lakh",
];

export const TIMELINE_OPTIONS = [
  "Immediately", "Within 7 days", "Within 30 days", "1–3 months", "3+ months", "Just exploring",
];

export const CONSULTATION_FEE = 299;
